<template>
    <div class="row">
        <div class="card">
            <div class="card-header flex flex-col justify-between items-center">
                <h2>Lista de Notícias</h2>
                <router-link
                    to="/sistema/noticias/nova-noticia"
                    class="btn btn-primary"
                    >Nova Notícia</router-link
                >
            </div>
            <div class="card-body">
                <vue-good-table
                    @on-page-change="onPageChange"
                    @on-sort-change="onSortChange"
                    @on-per-page-change="onPerPageChange"
                    ref="vue-good-table"
                    :columns="noticias.columns"
                    :rows="noticias.rows"
                    :totalRows="noticias.total"
                    :responsive="true"
                    :pagination-options="{
                        enabled: true,
                        perPage: 10,
                        nextLabel: 'Próximo',
                        prevLabel: 'Anterior',
                        rowsPerPageLabel: 'Resultados por página',
                        ofLabel: 'de',
                        pageLabel: 'página',
                        allLabel: 'Todos'
                    }"
                    styleClass="vgt-table striped"
                >
                    <div slot="emptystate">
                        <div class="text-center">
                            <p>Nenhuma notícia foi cadastrada ainda.</p>
                        </div>
                    </div>
                    <template slot="table-row" slot-scope="props">
                        <div v-if="props.column.field === 'categoria'"></div>

                        <div
                            v-if="props.column.field === 'acoes'"
                            class="flex flex-col"
                        >
                            <!--<div
                                class="h-6  mb-2"
                                title="Visualizar Notícia"

                            >
                                <router-link :to="{path: '/noticias/noticia/'+ props.row.id}" target="_blank">
                                    <svg-icon
                                        icon="search-light"
                                        class="cursor-pointer text-primary"
                                    ></svg-icon>
                                </router-link>

                            </div>-->
                            <div
                                class="h-6  mb-2"
                                title="Editar Notícia"
                                @click.prevent="
                                    () =>
                                        $router.push(
                                            `/sistema/noticias/editar-noticias/${props.row.id}`
                                        )
                                "
                            >
                                <svg-icon
                                    icon="pencil"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                            <div
                                class="h-6"
                                title="Excluir Notícia"
                                @click="deleteNoticia(props.row)"
                            >
                                <svg-icon
                                    icon="delete"
                                    class="cursor-pointer text-primary"
                                >
                                </svg-icon>
                            </div>
                        </div>
                        <span>
                            {{ props.formattedRow[props.column.field] }}
                        </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>

<script>
import { VueGoodTable } from "vue-good-table";

export default {
    name: "listar-noticias",
    components: {
        VueGoodTable
    },
    data() {
        return {
            noticias: {
                columns: [
                    {
                        label: "Título",
                        field: "titulo"
                    },
                    {
                        label: "Categoria",
                        field: "categoria"
                    },
                    {
                        label: "Data da publicação",
                        field: "data_noticia"
                    },
                    {
                        label: "Tipo",
                        field: "manchete"
                    },
                    {
                        label: "Posição",
                        field: "posicao"
                    },
                    {
                        label: "Disponível",
                        field: "ativo"
                    },
                    {
                        label: "Visualizações",
                        field: "views"
                    },
                    {
                        label: "Ações",
                        field: "acoes",
                        filterable: false,
                        sortable: false,
                        width: "5%"
                    }
                ],
                rows: [],
                total: 0,
                filtros: {
                    sort: {
                        field: "id",
                        type: "desc"
                    },
                    page: 1,
                    perPage: 10
                }
            }
        };
    },
    methods: {
        /**
         * Altera a paginação
         * @param params
         */
        onPageChange(params) {
            this.filtrarNoticias({ page: params.currentPage });
        },

        /**
         * Filtra pela coluna conforme ascendente/descendente
         * @param params
         */
        onSortChange(params) {
            this.filtrarNoticias({
                sort: {
                    type: params[0].type,
                    field: params[0].field
                }
            });
        },

        /**
         * Altera a quantidade de registros por página
         * @param params
         */
        onPerPageChange(params) {
            this.filtrarNoticias({ perPage: params.currentPerPage });
        },

        /**
         * Filtra os eventos conforme as mudanças
         * @param newProps
         */
        filtrarNoticias(newProps) {
            this.noticias.filtros = Object.assign(
                {},
                this.noticias.filtros,
                newProps
            );
            this.getNoticias();
        },

        getNoticias() {
            this.axios
                .get("/noticias", {
                    params: {
                        page: this.noticias.filtros.page,
                        per_page: this.noticias.filtros.perPage,
                        sortField: this.noticias.filtros.sort.field,
                        sortType: this.noticias.filtros.sort.type
                    }
                })
                .then(response => {
                    this.noticias.rows = response.data.noticia.data;
                    this.noticias.total = response.data.noticia.total;

                    this.noticias.rows = this.noticias.rows.map(noticia => {
                        noticia.categoria = this.updateCategoria(
                            noticia.categoria
                        );
                        noticia.ativo = this.updateAtivo(noticia.ativo);
                        noticia.manchete = this.updateManchete(
                            noticia.manchete
                        );
                        noticia.posicao = this.updatePosicao(noticia.posicao);
                        return noticia;
                    });
                });
        },

        updateCategoria(value) {
            switch (value) {
                case "1":
                    return "UGT - Notícias";
                case "2":
                    return "Palavra do Presidente";
                case "3":
                    return "Comentario do Diretor";
            }
        },

        updateAtivo(value) {
            return value === 1 ? "Ativo" : "Inativo";
        },

        updateManchete(value) {
            return value === 1 ? "Notícia Destaque" : "Notícia Comum";
        },

        updatePosicao(value) {
            switch (value) {
                case 1:
                    return "Primeira Notícia";
                case 2:
                    return "Segunda Notícia";
                case 3:
                    return "Terceira Notícia";
                case 4:
                    return "Quarta Notícia";
                default:
                    return "-";
            }
        },

        deleteNoticia(row) {
            this.$swal({
                title: "Excluir Notícia",
                text: "Você deseja excluir esta notícia?",
                icon: "question",
                focusConfirm: false,
                showCancelButton: true,
                confirmButtonColor: "#6C9E1D",
                cancelButtonColor: "#E50053",
                cancelButtonText: "Não",
                confirmButtonText: "Sim"
            }).then(result => {
                if (result.value) {
                    this.axios
                        .delete(`/noticias/${row.id}`)
                        .then(response => {
                            this.$swal({
                                title: "Sucesso",
                                text: "A notícia foi excluida com sucesso!",
                                icon: "success"
                            });
                            this.noticias.rows.splice(row.originalIndex, 1);
                        })
                        .catch(error => {
                            this.$swal({
                                title: "Algo de errado ocorreu",
                                text: error.response.data.message,
                                icon: "error"
                            });
                        });
                }
            });
        }
    },
    mounted() {
        this.getNoticias();
    }
};
</script>
<style lang="scss" scoped>
.card-header {
    @media (min-width: 500px) {
        @apply flex-row;
    }
}
</style>
